import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column px-4 py-2" }
const _hoisted_2 = {
  class: "form-group col-12 offset-md-1 col-md-10 my-4",
  slot: "content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "You have 200 remaining characters.", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Patient Notes",
    "full-height": false,
    "application-id": _ctx.application,
    popoverContent: _ctx.popoverContent
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            id: "patient-notes",
            rows: "4",
            placeholder: "Enter Patient Notes",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientDetails.patientNotes.note) = $event)),
            maxlength: 200
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, _ctx.patientDetails.patientNotes.note]
          ]),
          _hoisted_3
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id", "popoverContent"]))
}